import { useBrowser } from 'hooks';
import React, { Fragment, useCallback, useRef, useState, } from 'react';
import { animated, useTransition } from 'react-spring';
import styled from 'styled-components';
import Header from './Header';
const ScrollWrapper = styled('div') `
  flex: 1;
  overflow: auto;
  margin-top: ${({ addTopMargin }) => (addTopMargin ? '40px' : '0')};
`;
const ScrollTracker = styled('div') `
  height: 0;
  overflow: hidden;
`;
const PageContainer = styled.div `
  position: ${({ index, isProductJourney, isIntegration, isMobile }) => isProductJourney
    ? 'absolute'
    : index === 0 && isIntegration
        ? 'relative'
        : isIntegration
            ? 'fixed'
            : isMobile
                ? 'fixed'
                : 'absolute'};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  min-height: ${({ isIntegration }) => (isIntegration ? 'unset' : '100vh')};
  min-height: -moz-available;
  min-height: -webkit-fill-available;
  min-height: fill-available;
  // set min-height to unset if isPaymentWidget is true to allow for the widget to be smaller than the screen and still be scrollable
  min-height: ${({ isIntegration, isPaymentWidget }) => isIntegration || isPaymentWidget ? 'unset' : '100dvh'};
  max-height: ${({ isIntegration }) => (isIntegration ? 'unset' : '100vh')};
  max-height: -moz-available;
  max-height: -webkit-fill-available;
  max-height: fill-available;
  max-height: ${({ isIntegration }) => (isIntegration ? 'unset' : '100dvh')};
  width: 100%;
  height: 100%;
  z-index: ${({ index }) => 9999999 + index};
  background: #fff;
  display: flex;
  border-radius: ${({ isProductJourney, isIntegration }) => isProductJourney && isIntegration ? '4px' : '0'};
`;
const PageTransitionContainer = ({ index, activePage, deactivatePage, children, createdBy, scrollRef, isIntegration = false, isProductJourney = false, isPaymentWidget = false, }) => {
    const transitions = useTransition(activePage.isActive, {
        from: { transform: 'translate3d(100%,0,0)' },
        enter: { transform: 'translate3d(0%,0,0)' },
        leave: { transform: 'translate3d(100%,0,0)' },
        initial: index === 0 ? null : undefined,
    });
    const layout = activePage.layout || {
        hasBackButton: false,
        hasHeader: false,
        hasHeaderScrollEffect: false,
    };
    const { isMobile } = useBrowser();
    const [isHeaderTransparent, setIsHeaderTransparent] = useState(layout.hasHeaderScrollEffect);
    const scrollTrackerRef = useRef(null);
    const updateHeaderScrollEffect = useCallback(() => {
        var _a;
        // If header scroll effect is turned on, we track the scroll position to set the transparency of the header.
        // This is done based on the position of the scrolltracker div.
        // Tracking the window position won't work here because of the absolute positioning of the pages being stacked on top of eachother.
        if (layout.hasHeaderScrollEffect) {
            const y = (_a = scrollTrackerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().y;
            if (y < 0 && isHeaderTransparent === true) {
                setIsHeaderTransparent(false);
            }
            if (y > 0 && isHeaderTransparent === false) {
                setIsHeaderTransparent(true);
            }
        }
    }, [activePage, isHeaderTransparent]);
    return (React.createElement(Fragment, null, transitions((style, item) => {
        if (item) {
            return (React.createElement(PageContainer, { index: index, isMobile: isMobile, as: animated.div, style: style, isIntegration: isIntegration, isProductJourney: isProductJourney, isPaymentWidget: isPaymentWidget },
                layout.hasHeader && (React.createElement(Header, { isHeaderTransparent: isHeaderTransparent, onNavigateBack: layout.hasBackButton
                        ? () => {
                            // Pressing the back button triggers the deactivate page function, which marks the page as inActive,
                            // so we can transition the page out.
                            deactivatePage(activePage.id);
                        }
                        : undefined, company: createdBy })),
                React.createElement(ScrollWrapper, { ref: scrollRef, 
                    // Needed as backup
                    id: "scroll-wrapper", "data-cy": "page-scroll-container", onScroll: updateHeaderScrollEffect, addTopMargin: layout.hasHeader === true },
                    React.createElement(ScrollTracker, { ref: scrollTrackerRef }),
                    children)));
        }
    })));
};
export default PageTransitionContainer;
